document.addEventListener("DOMContentLoaded", function() {

    document.addEventListener("click", (e) => {
        var fliterTriggers = document.querySelectorAll(".blm-product-search-filter");
        var targetClassList = e.target.classList;


        if(document.querySelector(".blm-product-search-toolbar")) {
            var resultMark = document.querySelector(".blm-product-search-toolbar .blm-product-search-toolbar__title");
            var resultText = resultMark.innerHTML;
            resultText = resultText.replace("products", "items");
            resultMark.innerHTML = resultText;
        }

        if(e.target.closest(".blm-product-search-filter")) {
            var targetFlag = e.target.closest(".blm-product-search-filter").classList.contains("active");

            if(targetClassList.contains("blm-product-search-filter-title") == true) {

                fliterTriggers.forEach(item => {
                    item.classList.remove("active");
                });

                if(targetFlag == false) {
                    e.target.closest(".blm-product-search-filter").classList.add("active");
                }
            }
        } else {
            fliterTriggers.forEach(item => {
                item.classList.remove("active");
            });
        }

        if(document.querySelector(".blm-product-search-sidebar-content.blm-open")) {
            var bodyTarget = document.querySelector("body");
            if(e.target == bodyTarget) {
                document.querySelector(".blm-product-search-sidebar-content.blm-open").classList.remove("blm-open");
            }
        }
    });


    actionMobileFilter();

    function actionMobileFilter() {
        var filterTimer;
        filterTimer = setInterval(function() {
            if(document.querySelector(".blm-product-search-sidebar-content")) {
                var filterMobile = document.querySelector(".blm-product-search-sidebar-content");

                var addCloseButton = `<svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <g filter="url(#filter0_b_1328_50881)">
                                    <path d="M5.09082 23.1632L14.2545 13.9996M14.2545 13.9996L23.4181 4.83594M14.2545 13.9996L5.09082 4.83594M14.2545 13.9996L23.4181 23.1632" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </g>
                                <defs>
                                    <filter id="filter0_b_1328_50881" x="-14.1667" y="-14.1667" width="56.3333" height="56.3333" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="7.08333"></feGaussianBlur>
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1328_50881"></feComposite>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1328_50881" result="shape"></feBlend>
                                    </filter>
                                </defs>
                                </svg>`;

                var filterColseEle = document.createElement("div");
                filterColseEle.classList.add("btn-mobile-filter-close");

                filterColseEle.innerHTML = addCloseButton;

                filterMobile.appendChild(filterColseEle);

                filterColseEle.addEventListener("click", function() {
                    document.querySelector(".blm-product-search-sidebar-content.blm-open").classList.remove("blm-open");
                });
                clearInterval(filterTimer);
            }

            if(document.querySelector(".blm-product-search-toolbar-options__select") && window.innerWidth < 680) {
                sortItem = document.querySelector(".blm-product-search-toolbar-options__select");
                var opt = document.createElement("option");
                opt.innerHTML = "Sort By";
                opt.setAttribute("disabled", true);
                sortItem.prepend(opt);
                sortItem.value = "Sort By";
            }

            if(document.querySelector(".blm-product-search-toolbar")) {
                var resultMark = document.querySelector(".blm-product-search-toolbar .blm-product-search-toolbar__title");
                var resultText = resultMark.innerHTML;
                resultText = resultText.replace("products", "items");

                resultMark.innerHTML = resultText;
            }

        }, 500);



        var searchField = document.querySelector(".search-modal .search-modal__content input.search__input");
        searchField.addEventListener("keydown", function() {
            var searchTimer;

            clearInterval(searchTimer);
            searchTimer = setInterval(function() {
             if(document.querySelector(".blm-autosuggest-search-results .blm-autosuggest__results-container")) {
                document.querySelector("body").classList.add("has-autosuggest");
                if(document.querySelector(".blm-autosuggest-search-results .blm-btn-search-all-result")) {
                    return;
                }
                var inValue = document.querySelector(".search-modal .search-modal__content input.search__input").value;
                var all_result = document.createElement("a");
                all_result.classList.add("blm-btn-search-all-result");
                all_result.innerHTML = `Show all results<svg style='margin-left : 10px;' xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" width="8" height="14" viewBox="0 0 8 14" fill="none">
                                        <path d="M1 1L7 7L0.999998 13" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round"></path>
                                        </svg>`;
                all_result.href = "/search?q=" + inValue;
                document.querySelector(".blm-autosuggest-search-results .blm-autosuggest__results-container").appendChild(all_result);
                clearInterval(searchTimer);
             } else {
                document.querySelector("body").classList.remove("has-autosuggest");
             }
            });
        });
    }

});
